import { render, staticRenderFns } from "./MarketingActivities.vue?vue&type=template&id=57788c6d&scoped=true&"
import script from "./MarketingActivities.vue?vue&type=script&lang=js&"
export * from "./MarketingActivities.vue?vue&type=script&lang=js&"
import style0 from "./MarketingActivities.vue?vue&type=style&index=0&id=57788c6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57788c6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57788c6d')) {
      api.createRecord('57788c6d', component.options)
    } else {
      api.reload('57788c6d', component.options)
    }
    module.hot.accept("./MarketingActivities.vue?vue&type=template&id=57788c6d&scoped=true&", function () {
      api.rerender('57788c6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MarketingActivities/MarketingActivities.vue"
export default component.exports